'use client';
import { LifeBuoy } from "lucide-react";
import { ContactDialog } from "./dialogs/contact-dialog";
import LanguageSwitcher from "./language-switcher";
import ThemeSwitcher from "./theme-switcher";
import { Button } from "./ui/button";
import { SidebarTrigger } from "./ui/sidebar";

const Header = () => {
      return <header className="flex flex-col gap-2 px-4 h-16 w-full">
            <div className="flex items-center gap-2 h-16 justify-between">
                  <SidebarTrigger />
                  <div className="flex items-center gap-2 m-auto justify-end w-full">
                        <ContactDialog>
                              <Button variant="ghost" size="icon">
                                    <LifeBuoy className="w-4 h-4" />
                              </Button>
                        </ContactDialog>
                        <ThemeSwitcher />
                        <LanguageSwitcher />
                  </div>
            </div>
      </header>;
};

export default Header;


